import {BUSINESS_FEATURE_IDS} from '../../common/adminModuleCatalog.js';
import {api} from '../api.js';
import {apiUrl} from '../config.js';

export type ProfessionalModuleAccess={'finance-management':boolean;'legal-compliance-assistant':boolean};
export type LegalFeatureAccess=Record<string,boolean>;
let access:ProfessionalModuleAccess={'finance-management':true,'legal-compliance-assistant':false};
let features:LegalFeatureAccess=Object.fromEntries(BUSINESS_FEATURE_IDS.map((id)=>[id,true]));
export function getProfessionalModuleAccess():ProfessionalModuleAccess{return access;}
/**
 * 法务等业务模块下的次级功能开关；接口未返回时默认开启。
 */
export function getLegalFeatureAccess():LegalFeatureAccess{return features;}
/**
 * 判断某项次级功能是否可用。
 * @param featureId 功能 ID
 */
export function isBusinessFeatureEnabled(featureId:string):boolean{return features[featureId]!==false;}
export function isLegalFeatureEnabled(featureId:string):boolean{return isBusinessFeatureEnabled(featureId);}
export async function refreshProfessionalModuleAccess():Promise<ProfessionalModuleAccess>{
  try{
    const payload=await api.get<{modules?:Partial<ProfessionalModuleAccess>;features?:Partial<LegalFeatureAccess>}>(apiUrl('/api/tasks/module-access'));
    access={'finance-management':payload.modules?.['finance-management']!==false,'legal-compliance-assistant':payload.modules?.['legal-compliance-assistant']===true};
    features=Object.fromEntries(BUSINESS_FEATURE_IDS.map((id)=>[id,payload.features?.[id]!==false]));
  }catch{
    access={'finance-management':true,'legal-compliance-assistant':false};
    features=Object.fromEntries(BUSINESS_FEATURE_IDS.map((id)=>[id,true]));
  }
  return access;
}
